import { transitionToPlaying } from '../../utils/astrapos/stageTransitions';
import GameCountdown from './GameCountdown';

/**
 * WINNER_DISPLAY stage: Show each player their assigned role
 * Personal announcement of role assignment (not global winner announcement)
 */
const RoleAssignmentDisplay=({
  roomId,
  roomData,
  userData,
  role,
  winnerDisplayDuration=10,
}) => {
  const isWinner=roomData.stakingWinner===userData.publicKey;
  const assignedRole=isWinner? 'Validator':'Participant';
  const roleColor=isWinner
    ? 'from-yellow-500 to-orange-500'
    :'from-blue-500 to-cyan-500';
  const roleIcon=isWinner? '⛏️':'👤';

  // Auto-transition to PLAYING after countdown
  const handleExpiry=async () => {
    try {
      await transitionToPlaying(roomId);
    } catch (error) {
      console.error('Error transitioning to PLAYING:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center pt-10 pb-8 px-6">
      <div className="w-full max-w-2xl space-y-6">
        {/* Role Announcement Card */}
        <div
          className={`bg-gradient-to-br ${roleColor} rounded-2xl p-12 border-2 border-white/20 shadow-2xl`}
        >
          <div className="text-center space-y-6">
            {/* Role Icon */}
            <div className="text-7xl animate-bounce">{roleIcon}</div>

            {/* Role Title */}
            <div>
              <p className="text-white/80 text-xl font-semibold mb-2">
                Staking Game Complete!
              </p>
              <h1 className="text-5xl font-bold text-white">Your Role is:</h1>
            </div>

            {/* Role Name */}
            <div className="text-6xl font-black text-white drop-shadow-lg">
              {assignedRole}
            </div>

            {/* Role Description */}
            <div className="bg-white/20 rounded-xl p-6 backdrop-blur">
              {isWinner? (
                <div className="text-white text-lg">
                  <p className="font-semibold mb-2">
                    🏆 You won the staking game!
                  </p>
                  <p className="text-white/90">
                    You will validate transactions and mine blocks during this
                    round.
                  </p>
                </div>
              ):(
                <div className="text-white text-lg">
                  <p className="font-semibold mb-2">
                    Create transactions and earn rewards
                  </p>
                  <p className="text-white/90">
                    You will participate in creating transactions for
                    validation.
                  </p>
                </div>
              )}
            </div>

            {/* Countdown */}
            <div className="text-center pt-4">
              <p className="text-white/80 text-sm mb-3">Game starting in</p>
              <GameCountdown
                endsAt={roomData.gameState?.stageEndsAt}
                onExpiry={handleExpiry}
              />
            </div>
          </div>
        </div>

        {/* Info Card */}
        <div className="bg-white/5 backdrop-blur rounded-xl p-6 border border-white/10">
          <p className="text-white/80 text-sm text-center">
            Get ready! The main game phase will begin shortly where you'll use
            your assigned role to participate.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoleAssignmentDisplay;
